import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative h-screen-90">
      <div className="absolute inset-0">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/vqtarna-melnica.firebasestorage.app/o/media%2F1763559963345_0-02-05-5c354c2a2ffac600ba43a7cf9fba2fe72af88eb750095ec8a40b107198f671fa_a203e2d580f0dd5a.jpg?alt=media&token=8bfad642-b9c5-487a-a8bc-3e4dbf3ead68"
          alt="Сграда Molino"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40" />
      </div>
      
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="container-custom text-center text-white">
          <h1 className="font-serif text-4xl md:text-6xl font-bold mb-4">
            Модерна жилищна сграда
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto">
            Съвременна архитектура и уникален стил в град Варна
          </p>
          <Link
            to="/apartments"
            className="inline-flex items-center space-x-2 bg-accent text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-accent-dark transition duration-300"
          >
            <span>Разгледайте апартаментите</span>
            <ChevronRight size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;